// extracted by mini-css-extract-plugin
export default {"body":"KV3S3A","cbdBannerWrapper":"M_Xw3m","searchFadeIn":"BmUUsS"};